import { DefaultError } from '@tanstack/query-core'
import { QueryClient, useMutation, UseMutationOptions, UseMutationResult } from '@tanstack/react-query'
import { useSession } from '../session'

export default function useApiMutation<TData = unknown, TError = DefaultError, TVariables = void, TContext = unknown>(
  options: UseMutationOptions<TData, TError, TVariables, TContext>,
  queryClient?: QueryClient
): UseMutationResult<TData, TError, TVariables, TContext> {
  const session = useSession()

  return useMutation(
    {
      ...options,
      mutationFn: options.mutationFn
        ? async (variables: TVariables) => {
            try {
              return await options.mutationFn!(variables)
            } catch (err: any) {
              if (err && err.code === 401) {
                session.invalidate()
              }
              throw err
            }
          }
        : undefined,
    },
    queryClient
  )
}
